import Vue from 'vue'
import { VueWindowSizePlugin } from 'vue-window-size/option-api'

Vue.use(VueWindowSizePlugin)
